import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDelete = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M2.32838 3.59766H13.6716C13.8533 3.59766 14 3.72955 14 3.89293V14.5211C14 15.338 13.2632 16.0005 12.3548 16.0005H3.64523C2.73677 16.0005 2 15.338 2 14.5211V3.89293C2 3.72955 2.14669 3.59766 2.32838 3.59766Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.3333 0.899414H1.66667C1.29848 0.899414 1 1.16783 1 1.49895V2.09848C1 2.42959 1.29848 2.69801 1.66667 2.69801H14.3333C14.7015 2.69801 15 2.42959 15 2.09848V1.49895C15 1.16783 14.7015 0.899414 14.3333 0.899414Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3 0.899297H4.51976C4.98405 0.899297 5.56595 0 6.185 0H7.8069V1.19607",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.0193 0.899297C13.0193 0.899297 11.8307 0.899297 11.3665 0.899297C10.9022 0.899297 10.4534 0 9.83432 0C9.21527 0 7.00682 0 7.00682 0L6.93408 1.19607",
			fill: "currentColor"
		})
	] }), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_6667_117668",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white"
		})
	}) })]
});
export default SvgDelete;
